/**
 * Spec 069: a tela de quem entrou sem grupo de permissão numa empresa que exige. No lugar do app, um aviso com o que
 * fazer e o botão de sair. A API já recusa tudo o que pede permissão.
 */
import { LogOut, ShieldAlert } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { performLogout } from '@/auth/logout';
import { Button } from '@/components/ui/button';
import { PERMISSION_GROUP_REQUIRED_TEXT, PERMISSION_GROUP_REQUIRED_TITLE } from './permission-group-gate';

export function NoPermissionGroup() {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-4 rounded-lg border bg-card p-6 text-center shadow-sm">
        <ShieldAlert className="mx-auto size-10 text-muted-foreground" aria-hidden />
        <h1 className="text-lg font-semibold">{PERMISSION_GROUP_REQUIRED_TITLE}</h1>
        <p className="text-sm text-muted-foreground">{PERMISSION_GROUP_REQUIRED_TEXT}</p>
        <Button variant="outline" onClick={() => performLogout(() => void navigate({ to: '/login' }))}>
          <LogOut />
          Sair
        </Button>
      </div>
    </main>
  );
}
